import { createContext } from "react";

export const TableNameContext = createContext();
export const DataGridSetterContext = createContext();
export const CredsContext = createContext();
export const CredsSetterContext = createContext();
export const LogContext = createContext();

export const HelpModeContext = createContext();
